var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShutdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8,
    r: 12,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_1719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62174 13.916C6.44538 12.0176 7.25617 10.298 8.60097 9.2055C9.12517 8.77928 9.90903 9.14426 9.90903 9.81788C9.90903 10.0653 9.79145 10.2931 9.60038 10.4474C8.64751 11.2239 8.07432 12.4487 8.21394 13.8008C8.39521 15.5621 9.80615 16.9877 11.5649 17.1836C13.8601 17.4409 15.81 15.6429 15.81 13.3991C15.81 12.2086 15.2588 11.1431 14.399 10.445C14.208 10.2906 14.0928 10.0628 14.0928 9.81788C14.0928 9.15161 14.8644 8.77438 15.3837 9.1908C16.6134 10.1829 17.4022 11.6991 17.4022 13.3991C17.4022 16.5076 14.7616 19.0135 11.6041 18.7856C8.9929 18.6019 6.86425 16.5223 6.62174 13.916ZM11.9985 6.80005C11.5576 6.80005 11.2024 7.15768 11.2024 7.59615V11.2631C11.2024 11.704 11.56 12.0592 11.9985 12.0592C12.437 12.0592 12.7946 11.7016 12.7946 11.2631V7.59615C12.7946 7.15768 12.4394 6.80005 11.9985 6.80005Z",
    fill: "#5E6366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_1719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6.80005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShutdown);
export default __webpack_public_path__ + "static/media/ICON_SHUTDOWN.b3c281ec6325a66ed7306ac487a40c68.svg";
export { ForwardRef as ReactComponent };